"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bookmarkContext = _interopRequireDefault(require("../context/bookmarkContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var BookmarkCount = function BookmarkCount(_ref) {
  var className = _ref.className,
      _ref$hideZero = _ref.hideZero,
      hideZero = _ref$hideZero === void 0 ? true : _ref$hideZero,
      setVisible = _ref.setVisible;
  var bookmarkData = (0, _react.useContext)(_bookmarkContext.default)[0];
  (0, _react.useEffect)(function () {
    if (setVisible) {
      if (hideZero && bookmarkData.length === 0) {
        setVisible(false);
      } else {
        setVisible(true);
      }
    }
  }, [bookmarkData.length]); // eslint-disable-line react-hooks/exhaustive-deps

  if (hideZero && bookmarkData.length === 0) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, bookmarkData.length);
};

BookmarkCount.propTypes = {
  className: _propTypes.default.any,
  hideZero: _propTypes.default.bool,
  setVisible: _propTypes.default.func
};
var _default = BookmarkCount;
exports.default = _default;